/*
 * Product tile text-panel links — added 2026-08-19 (FINE)
 * On any product tile (.product-block: collection carousels, related products,
 * collection grids), clicking the text panel (.product-block-footer) navigates
 * to the PDP, same as clicking the image. Interactive controls inside the panel
 * (Add to Cart, quantity +/- and input, links) keep their own behaviour.
 * The PDP URL is derived from the tile's existing image link, so no per-section
 * markup changes are needed.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var footer = event.target.closest('.product-block-footer');
    if (!footer) return;

    // Let real controls do their thing.
    if (event.target.closest('a, button, input, select, textarea, label, .quantity-wrapper')) return;

    var block = footer.closest('.product-block');
    var link = block && block.querySelector('a.product-block-image[href]');
    if (link) window.location.href = link.href;
  });
})();
